/* eslint-disable */
__webpack_public_path__ =
  (typeof window === 'object' && window.publicPath) || __webpack_public_path__;
